import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@common/utils/analytics';
const PlpIntroTags = (props) => {
    const { t } = useTranslation();
    const readMoreText = useRef();
    const [readMoreOpen, setReadMoreOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row intro-plp__text-tags-wrapper", id: "pd-text-and-tags" },
            React.createElement("div", { className: "col-md-6 col-lg-5 intro-plp__text-container" },
                props.title && React.createElement("h1", { className: "intro-plp__title" }, props.title),
                props.description && React.createElement("div", { className: "intro-plp__description", dangerouslySetInnerHTML: { __html: props.description } }),
                props.readMore && (React.createElement(React.Fragment, null,
                    React.createElement("span", null, " "),
                    React.createElement("div", { className: "intro-plp__read-more-container" },
                        React.createElement("div", { className: "intro-plp__read-more-text", ref: readMoreText, dangerouslySetInnerHTML: { __html: props.readMore } }),
                        React.createElement("button", { className: "intro-plp__read-more-btn", onClick: () => {
                                readMoreText.current.classList.toggle('open');
                                setReadMoreOpen(!readMoreOpen);
                            } }, t(readMoreOpen ? 'button.readless' : 'button.readmore')))))),
            props.tags && (React.createElement("div", { className: "col-md-6 col-lg-7 intro-plp__tags-container" },
                React.createElement("ul", { className: "intro-plp__tags-list" }, props.tags.map((tag, i) => {
                    var _a;
                    return (React.createElement("li", { key: i, className: "intro-plp__tag__item" },
                        React.createElement("a", { className: "tag__link", href: tag.categoryLink || ((_a = tag.custom) === null || _a === void 0 ? void 0 : _a.categoryLink), onClick: () => analytics.visualFiltersAnalytics(tag.title_analytics || tag.title || tag.displayName) }, tag.title || tag.displayName)));
                })))))));
};
export default PlpIntroTags;
